// Dependencies
import React, { Component, PropTypes } from 'react';
// Components
import ConnectionsWidgetItem from './connections-widget-item';
import languagesObj from '../../../localization/languages.json';
const languageSettings = languagesObj['en-US'];

class ConnectionsWidget extends Component {
  render() {
    return (
      <div className="connections-widget">
        <ConnectionsWidgetItem
          {...this.props}
          sendRouteName={this.props.sendRouteName}
          data={this.props.connectionsStats.pendingRequestCount}
          routeName="/connections/requests"
          activeRoutes={['/connections/requests']}
          name={languageSettings.connections.routeNames.requests}
          counterStyle={{ backgroundColor: 'red' }}
        />
        <ConnectionsWidgetItem
          {...this.props}
          sendRouteName={this.props.sendRouteName}
          data={this.props.connectionsStats.pendingInviteCount}
          routeName="/connections/invitations"
          activeRoutes={['/connections/invitations']}
          name={languageSettings.connections.routeNames.invites}
        />
      </div>
    );
  }
}

ConnectionsWidget.propTypes = {
  sendRouteName: PropTypes.func,
  connectionsStats: PropTypes.object,
  searchInput: PropTypes.any,
};

export default ConnectionsWidget;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-left-nav/connections-widget.jsx